import { render, staticRenderFns } from "./SyncView.vue?vue&type=template&id=597c5ac7&scoped=true"
import script from "./SyncView.vue?vue&type=script&lang=js"
export * from "./SyncView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c5ac7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597c5ac7')) {
      api.createRecord('597c5ac7', component.options)
    } else {
      api.reload('597c5ac7', component.options)
    }
    module.hot.accept("./SyncView.vue?vue&type=template&id=597c5ac7&scoped=true", function () {
      api.rerender('597c5ac7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlimChatbot/SyncView.vue"
export default component.exports